import { UserFieldPermission } from "@app/areas/permissions/interfaces/permission";


export class SetPermissions {
    static readonly type = '[Permissions] Set permissions list';
    constructor(public payload: UserFieldPermission[]) { }
}

export class AddPermission {
    static readonly type = '[Permissions] Add a permission to existing list';
    constructor(public payload: UserFieldPermission) { }
}
